import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Container, Row, Col, media } from "styled-bootstrap-grid";
import easing from "ui/styles/easing";
import SearchIcon from "./searchIcon";
import Results from "./Results";
import theme from "ui/styles/theme";
import levenshteinDistance from "./levenshtein";
import { compose } from "react-apollo";
import withQuery from "containers/withQuery";
import gql from "graphql-tag";
import { withRouter } from "react-router";
import { toPlainText } from "../../../../utils/PlainText";
import withTranslations from "containers/withTranslations";
import LocalizedString from "ui/components/generic/LocalizedString";

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchString: "",
      searchActive: false,
      currentUrl: "",
      resultReady: false,
      displayText: "",
      status: "",
      results: "",
      searchToResults: "",
      loadedResults: [],
      filteredResults: [],
      dropdown: false,
      isMobile: false,
      suggested: "",
      dictionary: [],
      searching: false,
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.wrapperRef = React.createRef();
    this.inputRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  static propTypes = {
    visible: PropTypes.bool,
  };

  static defaultProps = {
    visible: false,
  };

  componentDidMount() {
    //Detect if mobile
    this.detectMobile();
    window.addEventListener("resize", this.detectMobile);
    //Listen for mouse clicks. Used for blur on an input field so the dropdown doesn't close on field selection
    document.addEventListener("mousedown", this.handleClickOutside);
    this.setState({ currentUrl: window.location });
    if (this.state.currentUrl !== "") {
      this.getParameter(this.state.currentUrl);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible && this.props.visible) {
      if (this.inputRef.current) {
        this.inputRef.current.focus();
      }
      //hold dictionary values from props
      let options = this.props.optionsSearch.dictionary;

      if (this.props.optionsSearch && this.state.dictionary.length === 0) {
        //Create an empty array to hold single values from the Wordpress dictionary
        let suggestions = [];
        //Loop through the Wordpress dictionary
        for (let i = 0; i < options.length; i++) {
          //Push word to an array
          suggestions.push(options[i].words);
        }
        /*
        Change state value to our previously created array
        It is neccessary because setState causes rerender meaning that
        if setState was in the for loop only last value from the array would be pushed to it
        */
        this.setState({ dictionary: suggestions });
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.detectMobile);
  }

  //Use levenshtein distance algorythm to see which string is the closest match
  spellCheck = (ar, keyword) => {
    //let ar = ['dol 53', 'dol53', 'keyboard'] //dummy test data
    //empty array to store results (compared and distance to it)
    let words = [];
    for (let i = 0; i < ar.length; i++) {
      //Create an object containing the word and its distance to the input word
      let obj = {
        word: ar[i],
        distance: levenshteinDistance(
          ar[i].toLowerCase(),
          keyword.toLowerCase()
        ),
      };
      //Push to array
      words.push(obj);
    }
    this.setState({ suggested: this.compareValues(words) });
  };

  //-----Compare Levenshtein distance and returns object that is the closest match-----
  compareValues = (arr) => {
    //Assigns a value of one of the objects to a variable (Can be actually any single value from this array)
    let minObject = arr[0];
    /*
    Loop through an array and compare to the previously assigned variable
    This is curious because it just compares all of the values from the same array with the first value
    If any of them is shorter then the first one then this object is returned 
    if not then it means that minObject is already the object with the lowest distance value
    */
    for (let i = 1; i < arr.length; i++) {
      if (arr[i].distance < minObject.distance) {
        minObject = arr[i];
      }
    }
    return minObject;
  };

  detectMobile = () => {
    const width = window.innerWidth;
    const isMobile = width <= theme.grid.breakpoints.lg;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  };

  handleSearch(term) {
    let plainTerm = toPlainText(term);
    this.setState({ searchString: plainTerm });
    this.filterResults(plainTerm);
    if (this.state.filteredResults.length !== 0) {
      if (!this.state.dropdown) {
        this.setState({ dropdown: true });
      }
    } else {
      this.setState({ dropdown: false });
    }
  }

  handleClickOutside(event) {
    if (this.wrapperRef.current !== null) {
      if (!this.wrapperRef.current.contains(event.target)) {
        this.handleBlur();
      }
    }
    //  if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
    //   this.handleBlur();
    //  }
  }

  filterResults = (x) => {
    let query = x;
    let filteredResults = [];
    filteredResults = this.state.loadedResults.filter(
      (item) =>
        item.title
          .toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) !== -1
    );
    this.setState({ filteredResults });
  };

  handleCallback = (results, status) => {
    //Wait for translations to be available and populate state with translated phrases
    if (this.props.translations) {
      let labels = this.props.translations.searchLabels;
      let sorryMessage = labels.sorry_message;
      let searchingLabel = labels.searching_label;
      let foundLabel = labels.found_label;
      if (results > 0 && !status) {
        this.setState({
          displayText: foundLabel + " " + "'" + this.state.searchString + "'",
        });
        this.setState({ status: status, results: results, searching: false });
      } else if (results === 0 && !status && this.props.translations) {
        this.setState({
          displayText: sorryMessage + " " + "'" + this.state.searchString + "'",
        });
        this.setState({ status: status, results: results, searching: false });
        this.spellCheck(this.state.dictionary, this.state.searchString);
      } else {
        this.setState({ displayText: searchingLabel, searching: true });
      }
    }
  };
  handleFocus() {
    if (this.state.filteredResults.length !== 0) {
      this.setState({ dropdown: true });
    }
  }

  handleBlur() {
    this.setState({ dropdown: false });
    if (!this.state.searchActive) {
      //this.setState({ searchString: '' })
    }
  }

  getParameter = (a) => {
    const url = new URL(a);
    const sp = new URLSearchParams(a);
    if (url.searchParams.has("q")) {
      this.setState({ searchString: sp.get("q") });
    } else {
    }
  };
  //Data from Results
  pullResults = (data) => {
    if (this.state.loadedResults.length === 0) {
      this.setState({ loadedResults: data });
    }
  };

  changeValue = (a) => {
    //Change input's value to the value that was clicked in the dropdown
    this.handleSearch(a);
    this.setState({ dropdown: false });
    //When option is clicked in the dropdown, form is submitted
    let submitButton = document.getElementById("submitButton");
    //First focus on the button in order to trigger handleFocus - That closes a dropdown
    //Therafter submit the form to start searching (handleQuery)
    //Delay to make sure that searchToResults is populated correctly
    setTimeout(() => {
      submitButton.focus(submitButton.click());
    }, "250");
  };

  //Function used in a dropdown to limit displayed options based on the device
  limitValues = () => {
    if (this.state.isMobile) {
      return 5;
    } else {
      return 10;
    }
  };
  handleQuery = (event) => {
    event.preventDefault();
    this.setState({ dropdown: false });
    this.setState({
      currentUrl: window.location.href,
      searchToResults: this.state.searchString,
    });
    const url = new URL(this.state.currentUrl);
    if (this.state.searchActive !== true) {
      this.setState({ searchActive: true });
    }
    const sp = new URLSearchParams(this.state.currentUrl);
    if (url.searchParams.has("q")) {
      sp.set("q", this.state.searchString);
    } else {
      sp.append("q", this.state.searchString);
    }
    window.history.replaceState(null, "", `?q=${sp.get("q")}`);
  };

  render() {
    if (!this.props.optionsSearch) return null;
    const { visible, optionsSearch, match } = this.props;

    const {
      searchString,
      searchActive,
      displayText,
      searchToResults,
      isMobile,
      suggested,
      searching,
    } = this.state;

    const { dictionary } = optionsSearch;

    return (
      <AnimatedWrapper visible={visible}>
        <Wrapper visible={visible}>
          <AnimatedContainer searchActive={searchActive}>
            <Container fluid>
              <Row>
                <Col lg={11} xl={6} xlOffset={2}>
                  <SearchContainer>
                    <Form onSubmit={this.handleQuery}>
                      <InputIcons>
                        <Icon>
                          <SearchIcon />
                        </Icon>
                        <Input
                          innerRef={this.inputRef}
                          value={searchString}
                          placeholder={
                            this.props.translations !== false
                              ? this.props.translations.searchLabels
                                  .search_placeholder
                              : "Search"
                          }
                          type="text"
                          searchActive={searchActive}
                          onChange={(e) => this.handleSearch(e.target.value)}
                          onFocus={() => this.handleFocus()}
                          //onBlur={() => this.handleBlur()}
                          //ref={input => { this.inputRef = input }}
                        />
                      </InputIcons>
                      <SearchButton
                        type="submit"
                        onFocus={() => this.handleBlur()}
                        id="submitButton"
                      >
                        <LocalizedString
                          group="searchLabels"
                          string="search_button"
                        />
                      </SearchButton>
                      {/* onClick={() => this.handleQuery()} */}
                    </Form>
                    {this.state.dropdown && (
                      <Dropdown innerRef={this.wrapperRef}>
                        {this.state.filteredResults
                          .slice(0, this.limitValues())
                          .map((a, i) => {
                            return (
                              <ListItem
                                key={i}
                                onClick={() => this.changeValue(a.title)}
                                value={a.title}
                              >
                                {isMobile && a.title.length > 32
                                  ? toPlainText(a.title).slice(0, 32) + "..."
                                  : toPlainText(a.title)}
                              </ListItem>
                            );
                          })}
                      </Dropdown>
                    )}
                  </SearchContainer>
                </Col>
              </Row>
              <Row>
                <Col xl={6} xlOffset={2}>
                  {searchActive && (
                    <Found>
                      {displayText}
                      {searching && (
                        <Dots>
                          <span>.</span>
                          <span>.</span>
                          <span>.</span>
                        </Dots>
                      )}
                    </Found>
                  )}
                  {this.state.results === 0 &&
                    !this.state.status &&
                    searchActive &&
                    !this.state.searching && (
                      <div>
                        <NotFoundMini>
                          <LocalizedString
                            group="searchLabels"
                            string="not_found"
                          />
                        </NotFoundMini>
                        {suggested && suggested.distance < 3 && (
                          <Suggestion>
                            <LocalizedString
                              group="searchLabels"
                              string="did_you_mean"
                            />{" "}
                            <span
                              onClick={() => this.changeValue(suggested.word)}
                            >
                              {suggested.word}
                            </span>
                            ?
                          </Suggestion>
                        )}
                      </div>
                    )}
                </Col>
              </Row>
            </Container>
            <Results
              parentCallback={this.handleCallback}
              visible={searchActive}
              search={searchToResults}
              pullResults={this.pullResults}
              language={match}
            />
          </AnimatedContainer>
        </Wrapper>
      </AnimatedWrapper>
    );
  }
}

export default compose(
  withRouter,
  withQuery(
    () => gql`
      {
        optionsSearch {
          dictionary {
            words
          }
        }
      }
    `,
    "optionsSearch"
  ),
  withTranslations()
)(Search);

// Styles
const AnimatedWrapper = styled.div``;

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: white;
  z-index: 19;
  overflow: auto;
  overscroll-behavior: contain;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  visibility: ${(props) => (props.visible ? "visible" : "hidden")};
  transition: opacity 0.2s ${easing.easeOutCubic};
`;
const Icon = styled.i`
  position: absolute;

  ${media.lg`
  top: 15%;
  `}
`;
const InputIcons = styled.div`
  width: 100%;
`;
const Dropdown = styled.ul`
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 0;
  z-index: 1;
  top: 52px;
  width: 100%;

  ${media.sm`
top: 70px;
`}
`;

const Suggestion = styled.div`
  span {
    font-style: italic;
    font-weight: 500;
    color: #004077;
    text-decoration: underline;
    cursor: pointer;
  }
`;

const ListItem = styled.li`
  list-style: none;
  cursor: pointer;
  height: 3em;
  line-height: 3em;
  padding-left: 3em;

  :hover {
    background-color: rgb(235, 235, 235);
  }
`;

const Found = styled.p`
  color: #004077;
  margin-top: 20px;
  font-size: 2em;
`;
const Dots = styled.span`
  display: inline-block;

  && > span {
    opacity: 1;
    animation: l 0.6s infinite alternate;
  }

  @keyframes l {
    to {
      opacity: 0.1;
    }
  }

  && :nth-child(2) {
    animation-delay: 0.2s;
  }

  && :nth-child(3) {
    animation-delay: 0.4s;
  }
`;

const Form = styled.form`
  display: flex;
  width: 100%;
`;

const AnimatedContainer = styled.div`
  margin-top: 10rem;
  height: 90%;
  transition: transform 0.8s ${easing.easeOutCubic};
  transform: ${(props) =>
    props.searchActive ? "translateY(0)" : "translateY(30vh)"};
`;
const Input = styled.input`
  font-size: 18px;
  width: 100%;
  border: 2px solid #004077;
  outline: none;
  padding: 10px 10px 10px 60px;
  color: #004077;

  ::placeholder {
    color: #004077;
    opacity: 1;
  }

  ${media.sm`
    font-size: 30px;
  `}
`;
const SearchButton = styled.button`
  background-color: green;
  width: 20%;
  font-size: 1em;
  color: white;
  text-transform: uppercase;
  border: none;

  ${media.sm`
  font-size: 1.5em;
`}
`;
const SearchContainer = styled.div`
  display: flex;
  position: relative;
`;
const NotFoundMini = styled.div`
  color: #004077;
`;



// WEBPACK FOOTER //
// ./src/ui/components/Navigation/Search/index.js